export default "__VITE_ASSET__CJp1cpCf__"